import Vue from 'vue'
import Router from 'vue-router'
import index from '@/pages/index'
import login from '@/pages/login'
import ship from '@/pages/product/ship'
import live from '@/pages/product/live'
import addProduct from '@/pages/product/add_product'
import scenic from '@/pages/product/scenic'
import sailings from '@/pages/settings/sailings'
import addSailings from '@/pages/settings/add_sailings'
import trip from '@/pages/product/trip'
import booking from '@/pages/product/booking'
import ads from '@/pages/settings/ads'
import addAds from '@/pages/settings/add_ads'
import orderList from '@/pages/order/order-list'
import refundList from '@/pages/order/refund-list'
import orderDetail from '@/pages/order/order-detail'
import cate from '@/pages/settings/cate'
import addCate from '@/pages/settings/add_cate'
import userList from '@/pages/user/user-list'
import guideList from '@/pages/user/guide-list'
import playsList from '@/pages/settings/booking/plays-list'
import playDailyList from '@/pages/settings/booking/play-daily-list'
import groupList from '@/pages/user/group'
import SailingsStock from '@/pages/settings/sailings_stock'
import adminList from '@/pages/settings/admin/admin_list'
import adminGroup from '@/pages/settings/admin/admin_group'
import settings from '@/pages/settings/settings'
import configList from '@/pages/settings/soso/config_list'
import addConfig from '@/pages/settings/soso/add_config'
import cashList from '@/pages/order/cash-list'
import appList from '@/pages/settings/apps/app_list'
import payMerchantList from '@/pages/settings/pay_merchant/list'
import nightSailingList from '@/pages/settings/night_ship/sailing_list'
import nightSailingOrderList from '@/pages/settings/night_ship/order_list'
import nightReconciliationOrderList from '@/pages/settings/night_ship/reconciliation_list'
import orderReconciliationOrderList from '@/pages/order/reconciliation_list'
import opWallet from '@/pages/settings/op_wallet/op_wallet'
import contractPreview from '@/pages/contract/contract-preview'
import contractList from '@/pages/contract/contract-list'
import contractForm from '@/pages/contract/contract-form'
import supplierList from '@/pages/supplier/supplier-list'
import ticketProcessing from '@/pages/order/ticket-processing'
import meetingPointList from '@/pages/settings/meeting-point-list'
import communicateStat from '@/pages/dashboard/communicate-stat'
import intelligentHub from '@/pages/assistant/intelligent-hub'

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: index,
      meta: {
        title: '中旅策首页',
        group: 'index',
      }
    },
    {
      path: '/login',
      name: 'login',
      component: login,
      meta: {
        title: '欢迎来到中旅策客户管理系统',
        group: 'index',
      }
    },
    {
      path: '/product/ship',
      name: 'product.ship',
      component: ship,
      meta: {
        title: '船票套餐',
        group: 'shipList',
      }
    },
    {
      path: '/product/live',
      name: 'product.live',
      component: live,
      meta: {
        title: '直播列表',
        group: 'liveList',
      }
    },
    {
      path: '/product/add_ship',
      name: 'product.add_ship',
      component: addProduct,
      meta: {
        title: '添加船票',
        group: 'shipList',
      }
    },
    {
      path: '/product/edit_ship',
      name: 'product.edit_ship',
      component: addProduct,
      meta: {
        title: '编辑船票',
        group: 'shipList',
      }
    },
    {
      path: '/product/scenic',
      name: 'product.scenic',
      component: scenic,
      meta: {
        title: '景区门票',
        group: 'scenicList',
      }
    },
    {
      path: '/product/add_scenic',
      name: 'product.add_scenic',
      component: addProduct,
      meta: {
        title: '添加景区门票',
        group: 'scenicList',
      }
    },
    {
      path: '/product/edit_scenic',
      name: 'product.edit_scenic',
      component: addProduct,
      meta: {
        title: '编辑景区门票',
        group: 'scenicList',
      }
    },
    {
      path: '/product/trip',
      name: 'product.trip',
      component: trip,
      meta: {
        title: '线路套餐',
        group: 'tripList',
      }
    },
    {
      path: '/product/add_trip',
      name: 'product.add_trip',
      component: addProduct,
      meta: {
        title: '添加线路套餐',
        group: 'tripList',
      }
    },
    {
      path: '/product/booking',
      name: 'product.booking',
      component: booking,
      meta: {
        title: '预约套餐',
        group: 'bookingList',
      }
    },
    {
      path: '/product/edit_booking',
      name: 'product.edit_booking',
      component: addProduct,
      meta: {
        title: '编辑预约套餐',
        group: 'bookingList',
      }
    },
    {
      path: '/product/add_booking',
      name: 'product.add_booking',
      component: addProduct,
      meta: {
        title: '添加预约套餐',
        group: 'bookingList',
      }
    },
    {
      path: '/product/edit_trip',
      name: 'product.edit_trip',
      component: addProduct,
      meta: {
        title: '编辑线路套餐',
        group: 'tripList',
      }
    },
    //订单相关
    {
      path: '/order/order_list/ship',
      name: 'order.order_list.ship',
      component: orderList,
      meta: {
        title: '船票订单',
        group: 'orderList',
        goodsType: 11
      }
    },
    {
      path: '/order/order_list/trip',
      name: 'order.order_list.trip',
      component: orderList,
      meta: {
        title: '线路订单',
        group: 'tripLineOrder',
        goodsType: 10
      }
    },
    {
      path: '/order/order_list/scenic',
      name: 'order.order_list.scenic',
      component: orderList,
      meta: {
        title: '景区订单',
        group: 'scenicOrder',
        goodsType: 12
      },
    },
    {
      path: '/order/order_list/booking',
      name: 'order.order_list.booking',
      component: orderList,
      meta: {
        title: '预约订单',
        group: 'bookingOrder',
        goodsType: 14
      },
    },
    {
      path: '/order/order_list/all',
      name: 'order.order_list.all',
      component: orderList,
      meta: {
        title: '全部订单',
        group: 'allOrder',
        goodsType: 0
      },
    },
    {
      path: '/order/ticket_processing',
      name: 'order.ticket_processing',
      component: ticketProcessing,
      meta: {
        title: '出票处理',
        group: 'ticketProcessing',
      },
    },
    {
      path: '/refund/refund_list',
      name: 'refund.refund_list',
      component: refundList,
      meta: {
        title: '退款申请',
        group: 'refundList',
        goodsType: 0
      },
    },
    {
      path: '/order/detail',
      name: 'order.detail',
      component: orderDetail,
      meta: {
        title: '订单详情',
        group: 'orderList',
        goodsType: 11
      }
    },
    //设置相关信息
    {
      path: '/settings/sailings',
      name: 'settings.sailings',
      component: sailings,
      meta: {
        title: '航班管理',
        group: 'sailings',
      }
    },
    {
      path: '/settings/add_sailings',
      name: 'settings.add_sailings',
      component: addSailings,
      meta: {
        title: '添加航班',
        group: 'sailings',
      }
    },
    {
      path: '/settings/edit_sailings',
      name: 'settings.edit_sailings',
      component: addSailings,
      meta: {
        title: '编辑航班',
        group: 'sailings',
      }
    },
    {
      path: '/settings/edit_sailings/sailings_stock',
      name: 'settings.edit_sailings.sailings_stock',
      component: SailingsStock,
      meta: {
        title: '航班库存管理',
        group: 'sailings',
      }
    },
    {
      path: '/settings/meeting_point',
      name: 'settings.meeting_point',
      component: meetingPointList,
      meta: {
        title: '集合地点配置',
        group: 'meetingPoint',
      }
    },
    {
      path: '/settings/night_ship/sailing_list',
      name: 'settings.night_ship.sailing_list',
      component: nightSailingList,
      meta: {
        title: '夜游航班列表',
        group: 'night_ship',
      }
    },
    {
      path: '/settings/booking/plays_list',
      name: 'settings.booking.plays_list',
      component: playsList,
      meta: {
        title: '预约场次管理',
        group: 'plays_list',
      }
    },
    {
      path: '/settings/booking/plays_daily_list',
      name: 'settings.booking.plays_daily_list',
      component: playDailyList,
      meta: {
        title: '预约场次排班管理',
        group: 'plays_list',
      }
    },
    {
      path: '/settings/night_ship/order_list',
      name: 'settings.night_ship.order_list',
      component: nightSailingOrderList,
      meta: {
        title: '夜游订单列表',
        group: 'night_ship_order',
      }
    },
    {
      path: '/settings/night_ship/reconciliation_list',
      name: 'settings.night_ship.reconciliation_list',
      component: nightReconciliationOrderList,
      meta: {
        title: '对账单',
        group: 'night_ship_reconciliation_list',
      }
    },
    {
      path: '/settings/ads',
      name: 'settings.ads',
      component: ads,
      meta: {
        title: '广告管理',
        group: 'ads',
      }
    },
    {
      path: '/settings/add_ads',
      name: 'settings.add_ads',
      component: addAds,
      meta: {
        title: '添加广告',
        group: 'ads',
      }
    },
    {
      path: '/settings/edit_ads',
      name: 'settings.edit_ads',
      component: addAds,
      meta: {
        title: '编辑广告',
        group: 'ads',
      }
    },
    {
      path: '/settings/cate',
      name: 'settings.cate',
      component: cate,
      meta: {
        title: '产品分类',
        group: 'cate',
      }
    },
    {
      path: '/settings/add_cate',
      name: 'settings.add_cate',
      component: addCate,
      meta: {
        title: '添加分类',
        group: 'cate',
      }
    },
    {
      path: '/settings/soso/config_list',
      name: 'settings.soso.config_list',
      component: configList,
      meta: {
        title: '搜一搜配置列表',
        group: 'soso',
      }
    },
    {
      path: '/settings/soso/add_config',
      name: 'settings.soso.add_config',
      component: addConfig,
      meta: {
        title: '添加配置',
        group: 'soso',
      }
    },
    {
      path: '/settings/soso/edit_config',
      name: 'settings.soso.edit_config',
      component: addConfig,
      meta: {
        title: '编辑配置',
        group: 'soso',
      }
    },
    {
      path: '/user/user_list',
      name: 'user.user_list',
      component: userList,
      meta: {
        title: '用户列表',
        group: 'userList',
      }
    },
    {
      path: '/user/group_list',
      name: 'user.group_list',
      component: groupList,
      meta: {
        title: '用户组列表',
        group: 'group',
      }
    },
    {
      path: '/user/guide_list',
      name: 'user.guide_list',
      component: guideList,
      meta: {
        title: '讲解员列表',
        group: 'guideList',
      }
    },
    {
      path: '/settings/admin_list',
      name: 'settings.admin_list',
      component: adminList,
      meta: {
        title: '管理员列表',
        group: 'admin',
      }
    },
    {
      path: '/settings/admin_group',
      name: 'settings.admin_group',
      component: adminGroup,
      meta: {
        title: '管理员用户组',
        group: 'admin_group',
      }
    },
    {
      path: '/settings/settings',
      name: 'settings.settings',
      component: settings,
      meta: {
        title: '全局设置',
        group: 'settings',
      }
    },
    {
      path: '/cash/apply_list',
      name: 'cash.apply_list',
      component: cashList,
      meta: {
        title: '提现申请列表',
        group: 'cash',
      }
    },
    {
      path: '/order/reconciliation_list',
      name: 'order.reconciliation_list',
      component: orderReconciliationOrderList,
      meta: {
        title: '船票对账',
        group: 'orderReconciliation',
      }
    },
    {
      path: '/settings/apps/app_list',
      name: 'settings.apps.app_list',
      component: appList,
      meta: {
        title: '应用列表',
        group: 'apps',
      }
    },
    {
      path: '/settings/pay_merchant/list',
      name: 'settings.pay_merchant.list',
      component: payMerchantList,
      meta: {
        title: '支付商户管理',
        group: 'pay_merchant',
      }
    },
    {
      path: '/settings/op_wallet/op_wallet',
      name: 'settings.op_wallet.op_wallet',
      component: opWallet,
      meta: {
        title: '运营豆',
        group: 'op_wallet',
      }
    },
    {
      path: '/contract/preview',
      name: 'contract.preview',
      component: contractPreview,
      meta: {
        title: '旅游合同预览',
        group: 'contract',
      }
    },
    {
      path: '/contract/template_list',
      name: 'contract.template_list',
      component: contractList,
      meta: {
        title: '合同模板列表',
        group: 'contractTemplate',
      }
    },
    {
      path: '/contract/template_form',
      name: 'contract.template_form',
      component: contractForm,
      meta: {
        title: '合同模板编辑',
        group: 'contractTemplate',
      }
    },
    {
      path: '/supplier/list',
      name: 'supplier.list',
      component: supplierList,
      meta: {
        title: '供应商列表',
        group: 'supplier',
      }
    },
    {
      path: '/dashboard/communicate_stat',
      name: 'dashboard.communicate_stat',
      component: communicateStat,
      meta: {
        title: '客服沟通统计',
        group: 'communicateStat',
      }
    },
    {
      path: '/assistant/intelligent_hub',
      name: 'assistant.intelligent_hub',
      component: intelligentHub,
      meta: {
        title: '智能中心',
        group: 'intelligentHub',
      }
    },
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js